// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDQwHffecTGUFcYqtVMFSuKUaS2RhEd8V0",
    authDomain: "cryptogram-69.firebaseapp.com",
    projectId: "cryptogram-69",
    storageBucket: "cryptogram-69.appspot.com",
    messagingSenderId: "331749305114",
    appId: "1:331749305114:web:92a10621868e4e2aaf5aa3"
};

export default firebaseConfig;